import { Common, Widget } from '@stockbit/ui';
import { ScreenerTemplateType } from 'features/screener/types';
import Link from 'next/link';

import { ListContainer } from '../styled';
import { TYPE_CUSTOM_PRESET } from '../constants';

const { Text } = Common;
const { Button } = Widget;

interface ListScreenerTypes {
  dataScreenerCustom: any[];
  handleOnClickDetailPreset: (id: number, type: ScreenerTemplateType) => void;
}

const ListScreener = ({
  dataScreenerCustom,
  handleOnClickDetailPreset,
}: ListScreenerTypes) => (
  <div
    style={{
      height: 'calc(100% - 40px)',
      overflowY: 'auto',
      padding: '19px 12px 0',
    }}
  >
    <Link href="/screener">
      <a target="_blank" rel="noreferrer noopener">
        <Button
          block
          round
          height="35px"
          margin="0 0 12px"
          type="defaultHoverable"
        >
          <Text color="inherit" align="center">
            Create New Screener
          </Text>
        </Button>
      </a>
    </Link>
    {dataScreenerCustom.map((screener) => (
      <ListContainer
        key={screener.id}
        onClick={() =>
          handleOnClickDetailPreset(screener.id, TYPE_CUSTOM_PRESET)
        }
      >
        <Text size="14px" height="30px" as="a" style={{ flex: 1 }}>
          {screener.name}
        </Text>
      </ListContainer>
    ))}
  </div>
);

export default ListScreener;
